/**
 * Textos de ajuda da área Orquestrador (Configurações → IA).
 * F2.3: conteúdo fora de JSX de página — importar como módulo de “i18n” até existir sistema de traduções.
 */
export const orchestratorHelpPtBR = {
  overrideHint:
    'Escreva apenas o que a sua organização acrescenta ao baseline do produto. Não duplique o bloco de cima; o runtime junta baseline + override.',
  examplesPositiveHint:
    'Exemplos reais, um por linha. Ex.: "Tenho interesse no técnico de enfermagem e queria valores".',
  examplesNegativeHint:
    'Exemplos reais que NÃO devem disparar a mesma decisão. Ex.: "bom dia", "obrigado".',
  thresholdHint:
    'Valor entre 0 e 1. Abaixo do limiar, o sistema tende a pedir revisão humana em vez de aplicar automaticamente (conforme tipo de prompt).',
  drawerTitle: 'Exemplos e boas práticas',
  drawerBody: `Override
- "Para curso técnico, priorize responder: valor total, parcelas e início da turma."
- "Quando o lead citar bolsa, sempre mencionar as opções de 30% e 50% se disponíveis."
- Evitar: copiar o prompt inteiro do produto.

Exemplos positivos
- "Quero saber o valor da mensalidade de Enfermagem."
- "Vocês têm turma noturna de Administração?"
- "Posso me matricular ainda este mês?"

Exemplos negativos
- "Oi, tudo bem?"
- "Obrigado pela ajuda."
- "Depois eu vejo isso."

Threshold
- 0.70 (mais cobertura, aceita mais casos)
- 0.85 (mais conservador, reduz falso positivo)
- Ajuste em passos de 0.05 e valide com 20-30 conversas reais antes de produção.`,
} as const;
